import Hero from "@/components/home/Hero";
import LiveStats from "@/components/home/LiveStats";
import ServiceMix from "@/components/home/ServiceMix";
import Services from "@/components/home/Services";
import HowItWorks from "@/components/home/HowItWorks";
import DriverSection from "@/components/home/DriverSection";
import MerchantSection from "@/components/home/MerchantSection";
import TrustSafety from "@/components/home/TrustSafety";
import AppDownload from "@/components/home/AppDownload";
import useSeo from "@/lib/useSeo";

const HERO_IMG = "https://static.prod-images.emergentagent.com/jobs/e1b22ba1-7cff-4c1a-be5f-f374ac624625/images/c0b70ac9568bf91f72708967c384cd05b7fe22ba267d2ac4e7481e0c1c647090.png";

export default function Home() {
  useSeo({
    title: "Deliver Anything. Anytime. Anywhere",
    description:
      "IslandHop connects customers, businesses and independent pros across Trinidad & Tobago — delivery, handyman, cleaning, tech support and events on one Caribbean platform.",
    image: HERO_IMG,
  });
  return (
    <div data-testid="home-page">
      <Hero />
      <LiveStats />
      <ServiceMix />
      <Services />
      <HowItWorks />
      <DriverSection />
      <MerchantSection />
      <TrustSafety />
      <AppDownload />
    </div>
  );
}
